import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomeBanner from "./components/HomeBanner";
import AboutPage from "./components/About";
import Footer from "./components/footer";
import Testimonials from "./components/Testimonials";
import SkillUpComponent from "./components/SkillUp";
import ServicesComponent from "./components/Services";
import SmarticaLogin from "./components/SmarticaLogin";
import Clients from "./components/Clients";

const HomeComponent = () => {
  const serviceComponentRef = useRef(null);
  const skillUpComponentRef = useRef(null);
  const loginsComponentRef = useRef(null);
  const aboutComponentRef = useRef(null);

  const [activeServiceKey, setActiveServiceKey] = useState(1);
  const { hash } = useLocation();

  // Arriving from another route as /#services etc. — scroll once mounted.
  useEffect(() => {
    if (!hash) return;
    const element = document.getElementById(hash.slice(1));
    if (element) {
      requestAnimationFrame(() =>
        element.scrollIntoView({ behavior: "smooth", block: "start" })
      );
    }
  }, [hash]);

  return (
    <div className="flex flex-col">
      <Navbar />
      <HomeBanner />
      <AboutPage aboutComponentRef={aboutComponentRef} />
      <Clients />
      <ServicesComponent
        serviceComponentRef={serviceComponentRef}
        activeKey={activeServiceKey}
        setActiveKey={setActiveServiceKey}
      />
      <Testimonials />
      <SkillUpComponent skillUpComponentRef={skillUpComponentRef} />
      <SmarticaLogin loginsComponentRef={loginsComponentRef} />
      <Footer setActiveKey={setActiveServiceKey} />
    </div>
  );
};

export default HomeComponent;
